var _rect, _rect2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 400,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 400,
    fill: "#0d3b26"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 796,
    height: 396,
    fill: "none",
    stroke: "#3ECF8E",
    strokeWidth: 2,
    strokeDasharray: "12,6",
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 185,
    fontSize: 52,
    fill: "#3ECF8E",
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "monospace",
    opacity: 0.9
  }, "{\"{ }\"}")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 245,
    fontSize: 18,
    fill: "#7BBFA3",
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "sans-serif"
  }, "Image Coming Soon")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.308da7bdbdd128d2c1b31ba30a4aa872.svg";
export { ForwardRef as ReactComponent };